<template>
    <div class="overflow-y-auto banner-cookies">
        <v-banner
            v-if="mostrar"
            sticky
            class="mx-auto banner-contenido"
            elevation="8"
            :icon="icono"
            icon-color="#fdc20b"
            color="primary"
            dark
            transition="slide-y-transition"
        >
            {{ mensaje }}
            <router-link :to="enlace" style="color: #fdc20b">
                {{ textoEnlace }}
            </router-link>
            <template v-slot:actions="{ dismiss }" class="ma-0">
                <v-btn dark text color="red" @click="rechazarCookies">
                    {{ rechazarBoton }}
                </v-btn>
                <v-btn dark outlined @click="aceptarCookies">
                    {{ aceptarBoton }}
                </v-btn>
            </template>
        </v-banner>
    </div>
</template>
<script>
export default {
    name: "BannerCookies",
    data() {
        return {
            mostrar: true,
            mensaje: this.$t("componentes.banner-cookies.mensaje"),
            icono: "fa-cookie-bite",
            textoEnlace: this.$t("componentes.banner-cookies.texto-enlace"),
            enlace: { name: "cookies" },
            aceptarBoton: this.$t("componentes.banner-cookies.acepto"),
            rechazarBoton: this.$t("componentes.banner-cookies.rechazo"),
            direccionCookie: "/",
            dominioCookie: "",
            diasExpiacionCookie: 365,
        };
    },
    computed: {
        cookie() {
            return !this.recogerCookie(this.nombreCookie);
        },
    },
    methods: {
        aceptarCookies() {
            this.mostrar = false;
            this.editarCookies(
                this.nombreCookie,
                1,
                this.diasExpiacionCookie,
                this.dominioCookie,
                this.direccionCookie
            );
        },
        rechazarCookies() {
            this.mostrar = false;
            this.editarCookies(
                this.nombreCookie,
                0,
                this.diasExpiacionCookie,
                this.dominioCookie,
                this.direccionCookie
            );
        },
        recogerCookie(nombre) {
            let cookies = `; ${document.cookie}`;
            let parteCookie = cookies.split(`; ${nombre}=`);
            return parteCookie.length !== 2
                ? undefined
                : parteCookie.pop().split(";").shift();
        },
        editarCookies(nombre, valor, diasExpiacion, dominio, direccion) {
            let fechaExpiacion = new Date();
            fechaExpiacion.setDate(fechaExpiacion.getDate() + (diasExpiacion || 365));
            let cookie = [
                `${nombre}=${valor}`,
                `expires=${fechaExpiacion.toUTCString()}`,
                `path=${direccion || "/"}`,
            ];
            if (dominio) {
                cookie.push(`domain=${dominio}`);
            }
            document.cookie = cookie.join(";");
        },
    },
    beforeMount() {
        this.mostrar = this.cookie;
    },
};
</script>
<style>
.banner-cookies {
    position: fixed;
    overflow: hidden;
    box-sizing: border-box;
    z-index: 4;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    flex-direction: column;

    background-color: rgb(58 101 174 / 70%);

    bottom: 0;
}

.v-application--is-ltr .v-banner__actions {
    margin-bottom: 0;
}
</style>
